export function rankToRole(value) {
  // 系统实现时使用的角色，谨慎修改
  return (
    {
      0: "admin",
      1: "driver",
      2: "operator",
      4: "diamond"
    }[value] || "unknown"
  );
}

export function rankToRoleName(value) {
  // 外显名称，可随意修改
  return (
    {
      0: "Super Admin",
      1: "Driver",
      2: "Operator",
      4: "Super Admin"
    }[value] || "Unknown"
  );
}
